module.exports = __webpack_public_path__ + "img/inatray2x.80ec7721.png";